import { render, staticRenderFns } from "./tTable.vue?vue&type=template&id=089accac&"
import script from "./tTable.vue?vue&type=script&lang=ts&"
export * from "./tTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports